import { render, staticRenderFns } from "./CustList.vue?vue&type=template&id=996c41b0&scoped=true"
import script from "./CustList.vue?vue&type=script&lang=js"
export * from "./CustList.vue?vue&type=script&lang=js"
import style0 from "./CustList.vue?vue&type=style&index=0&id=996c41b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996c41b0",
  null
  
)

export default component.exports